import React, { useEffect, useRef } from "react";
import * as S from "../../style/StyleComponentSection";
import copyIcon from "../../assets/icons/content_copy.svg";
import price_system from "../../assets/images/ablack_construction_price_system_240430.jpg";
import { bnkAccount } from "../../Variable";

const PointCharge: React.FC = () => {
    const dotRef: any = useRef([]);

    useEffect(() => {
        if (!dotRef.current) return;
        for (let i = 0; i < dotRef.current.length; i++) {
            let width = dotRef.current[i].getBoundingClientRect().width;
            let count = Math.floor(width/30);
            const dots = '&bull;'.repeat(count);
            dotRef.current[i].innerHTML += dots;
        };
    }, []);

    const chargePointList = [
        {
            payment: "30 만원 결제",
            point: "300,000 AP",
        },
        {
            payment: "50 만원 결제",
            point: "500,000 AP",
        },
        {
            payment: "100 만원 결제",
            point: "1,050,000 AP (5% 추가적립)",
        },
        {
            payment: "200 만원 결제",
            point: "2,140,000 AP (7% 추가적립)",
        },
        {
            payment: "300 만원 결제",
            point: "3,300,000 AP (10% 추가적립)",
        },
    ];
    
    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>AP 포인트 충전</h1>
                    <h3>AP 포인트를 충전하는 방법을 알려드립니다.</h3>
                </S.SectionTitleBox>

                <S.ChargeChartBox style={{width: "640px"}}>
                    <div className="rows-box">
                        {chargePointList.map((tmp, idx) => 
                            <div
                                key={idx}
                                className="charge-rows"
                            >
                                <span className="start">{tmp.payment}</span>
                                <div
                                    ref={el => dotRef.current[idx] = el}
                                    className="expand-dot"
                                >
                                </div>
                                <span>{tmp.point}</span>
                            </div>
                        )}
                        {/* <div className="charge-rows">
                            <span>30 만원 결제</span>
                            <div className="expand-dot"></div>
                            <span>300,000 AP</span>
                        </div>
                        <div className="charge-rows">
                            <span>50 만원 결제</span>
                            <div className="expand-dot"></div>
                            <span>500,000 AP</span>
                        </div>
                        <div className="charge-rows">
                            <span>100 만원 결제</span>
                            <div className="expand-dot"></div>
                            <span>1,050,000 AP (5% 추가적립)</span>
                        </div>
                        <div className="charge-rows">
                            <span>200 만원 결제</span>
                            <div className="expand-dot"></div>
                            <span>2,140,000 AP (7% 추가적립)</span>
                        </div>
                        <div className="charge-rows">
                            <span>300 만원 결제</span>
                            <div className="expand-dot"></div>
                            <span>3,300,000 AP (10% 추가적립)</span>
                        </div> */}
                    </div>
                </S.ChargeChartBox>

                <div className="flex justify-center">
                    <div>
                        <div className="w-[640px] h-[150px] border-[0.5px] border-middleGray02 border-solid rounded-[5px] mx-auto mt-5 text-center relative">
                            <img
                                onClick={async () => {
                                    try {
                                        await navigator.clipboard.writeText("부산은행 113-2011-0981-05");
                                        alert('복사가 성공했습니다.');
                                    }
                                    catch (e) {
                                        alert('복사가 실패되었습니다.');
                                    }
                                }} className="absolute top-3 right-3 cursor-pointer" src={copyIcon} alt=""
                            />
                            <h1 className="mt-5 font-semibold">
                                {bnkAccount[0]}
                            </h1>
                            <p className="mt-[5px] mb-[27px] font-light">
                                {bnkAccount[1]}
                            </p>
                            <div className="px-5">
                                <hr />
                            </div>
                            <div className="flex justify-between px-6 mt-6">
                                <span className="font-light">전화번호</span>
                                <span className="font-semibold">051-558-1317</span>
                            </div>
                        </div>

                        <div className="w-[600px] pl-[30px] mt-5 font-light text-middleGray01">
                            <p>-  무통장입금으로 AP포인트 구매 가능</p>
                            <p>-  해당 금액 입금 확인 후 AP 포인트 충전</p>
                            <p>-  30만원 이하 금액 결제 불가 / 단건 거래 불가</p>
                            <p>-  세금 계산서 및 현금 영수증 발행이 가능</p>
                            <p>-  입금 후 연락 시 빠른 충전 처리 가능</p>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center mt-10">
                    <img width={800} src={price_system} alt="" />
                </div>
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default PointCharge;